import React from 'react';
import imagen from '../images/temis1.png';
import imagen2 from '../images/temis2.png';
import imagen3 from '../images/temis3.png';
import imagen4 from '../images/law22.png';
import manual1 from '../images/chatManualL.png'
import manual1D from '../images/chatManualD.png'
import manual2 from '../images/filtroManualL.png'
import manual2D from '../images/filtroManualD.png'
import manual2_1 from '../images/filtroManualD.png'
import manual3 from '../images/LeyLight.png'
import manual3D from '../images/LeyDark.png'
import manuel3 from '../images/manuel3.png'
import manuel4 from '../images/manuel4.png'
import manuel5 from '../images/manuel5.png'
import xLight from '../images/xLight.png'; 
import xDark from '../images/xDark.png'; 
import igLight from '../images/igLight.png'; 
import igDark from '../images/igDark.png'; 
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import Header from './header';
import '../styles/politica.css'
import '../styles/manual.css'

const Manuel = () => {
    const navigate = useNavigate();
    const { isDarkMode, themeClass, toggleTheme } = useTheme();
    
    const politica = () => navigate('/politica');
    const login = () => navigate('/login');
    const signup = () => navigate('/signup');

    return (
        <div className="main-container Politica">   
            <div className={`header-chat still plan ${themeClass}`}>
                <Header />
                |
                <div className="theme-toggle small-toggle">
                    <span className="colorIconToggle">☼</span>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={isDarkMode}
                            onChange={toggleTheme}
                            className="toggle-input"
                        />
                        <span className={`toggle-slider ${themeClass}`}>
                            <span className={`toggle-knob ${themeClass}`} />
                        </span>
                    </label>
                    <span className="colorIconToggle">☽</span>
                </div>
            </div>  
            
            <div className="manual-container">
                {/* Hero Section */}
                <div className={`manual-hero ${themeClass}`}>
                    <h1 className="manual-hero-title">Manual de Usuario</h1>
                    <div className="manual-hero-subtitle">Tu guía completa para dominar Temis</div>
                    <p className="manual-hero-description">
                        Bienvenido al Manual del Usuario de Temis. Este manual le ayudará a entender cómo usar correctamente la herramienta y aprovechar al máximo sus funciones.
                        Temis es una Inteligencia Artificial que actúa como asistente en el ámbito del derecho guatemalteco. Aunque aún no incluye el 100% del marco legal del país, se actualiza de forma constante para ampliar su cobertura.
                        Para usar Temis, solo debe hacer una pregunta. La herramienta buscará en su base de datos legal y le mostrará los artículos y normas más relevantes, presentando la información de manera clara y organizada para facilitar su estudio.
                        Temis no reemplaza el estudio tradicional ni el trabajo de los profesionales del derecho, ni ofrece asesoría legal. Su finalidad es facilitar el acceso a la legislación guatemalteca y servir como apoyo para el aprendizaje y la comprensión del marco legal.
                        
                    </p>
                </div>

                {/* Interface Section */}
                <div className={`manual-section ${themeClass}`} id="Interfaz">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>01</span>
                        <h2 className="section-titleM">Interfaz</h2>
                    </div>
                    
                    <p className={`section-descriptionM ${themeClass}`}>
                        La interfaz de Temis es intuitiva y se adapta automáticamente al dispositivo que esté utilizando. Con el fin de proporcionar instrucciones precisas y útiles.
                    </p>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Una vez que inicie sesión en su cuenta de Temis, se encontrará con la única y sencilla interfaz de trabajo que hemos diseñado para su comodidad. Esta interfaz consta de tres componentes principales:
                    </p>

                    <div className="interface-cards">
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">1</div>
                            <h3>Espacio de texto</h3>
                            <p>Este es el lugar donde podrá redactar y formular sus consultas.</p>
                        </div>
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">2</div>
                            <h3>Botón de generar</h3>
                            <p>Una vez redactada su pregunta, haga clic en este botón para que Temis procese su consulta y genere una respuesta basada en el marco legal guatemalteco.</p>
                        </div>
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">3</div>
                            <h3>Interruptor de opciones</h3>
                            <p>Este componente le permitirá ajustar ciertas preferencias y personalizar su experiencia de usuario.</p>
                        </div>
                    </div>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Cada componente de la interfaz ha sido diseñado con el objetivo de que su interacción con Temis sea sencilla, eficaz y satisfactoria.
                    </p>

                    <div className="image-showcase2">
                        <img 
                            src={isDarkMode ? manual1D : manual1} 
                            alt="temisChar" 
                            className="showcase-image2"                            
                        />
                    </div>

                    <div className={`tip-box ${themeClass}`}>
                        <div className="tip-icon">💡</div>
                        <div className="tip-content">
                            <strong>Consejo:</strong> Después de escribir su consulta, haga clic en “Generar” para que Temis procese su pregunta. Como Temis es una inteligencia artificial, puede ofrecer distintas respuestas para una misma consulta. Si la primera respuesta no cumple con sus expectativas, puede presionar “Generar” nuevamente para obtener una alternativa.

Esta variedad de respuestas es una de las principales características de Temis y le permite explorar diferentes enfoques y perspectivas sobre una misma cuestión legal.
                        </div>
                    </div>
                </div>

                {/* Filters Section */}
                <div className={`manual-section ${themeClass}`} id="Filtros">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>02</span>
                        <h2 className="section-titleM">Filtros de Documentos</h2>
                    </div>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Ubicado en la parte izquierda de la pantalla, encontrará un interruptor o 'switch' que activa la funcionalidad de filtrado por documentos. Este control le permite personalizar los resultados de su búsqueda, ajustándolos según sus necesidades o intereses específicos. Al activarlo, Temis refinará sus respuestas tomando en cuenta únicamente los documentos o tipos de documentos que usted haya seleccionado previamente. Esto resulta especialmente útil cuando desea concentrar su búsqueda en una categoría particular de documentos legales.
                    </p>

                    <div className="filter-comparison">
                        <div className={`comparison-card ${themeClass}`}>
                            <div className={`comparison-header disabled ${themeClass}`}>
                                <span className="comparison-icon">🔓</span>
                                <h3>Filtro Desactivado</h3>
                            </div>
                            <ul className="comparison-list">
                                <li>Temis realiza una búsqueda exhaustiva en todo el marco legal</li>
                                <li>Selecciona los artículos más relevantes para su consulta</li>
                                <li>Respuestas más generales debido al contexto extendido</li>
                                <li>Ideal para exploración amplia del marco legal</li>
                            </ul>
                        </div>
                        
                        <div className={`comparison-card ${themeClass}`}>
                            <div className={`comparison-header enabled ${themeClass}`}>
                                <span className="comparison-icon">🔒</span>
                                <h3>Filtro Activado</h3>
                            </div>
                            <ul className="comparison-list">
                                <li>Búsqueda enfocada en documentos específicos seleccionados</li>
                                <li>Respuestas más específicas y detalladas</li>
                                <li>Contexto centrado en temas particulares</li>
                                <li>Ideal para consultas especializadas</li>
                            </ul>
                        </div>
                    </div>

                    <div className="image-showcase2">
                        <img 
                            src={isDarkMode ? manual2D : manual2} 
                            alt="FiltrosDesactivados" 
                            className="showcase-image2"                            
                        />
                    </div>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Mientras la función de filtrado esté desactivada, Temis realizará una búsqueda exhaustiva en todo el marco legal, seleccionando los artículos más relevantes para su consulta y formulando una respuesta en consecuencia. Sin embargo, dado que Temis opera con un contexto limitado, mantener el filtro desactivado podría resultar en una respuesta más generalizada. Esto se debe a que el contexto de búsqueda se extiende a todos los documentos legales disponibles, lo cual no es necesariamente malo, pero si está buscando información más específica, se recomienda utilizar la función de filtrado.
                    </p>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Si desea obtener información detallada de ciertos documentos, o interactuar con la información específica de un documento o conjunto de documentos particulares, se recomienda activar el filtro de documentos. Esta acción hará que el contexto de búsqueda de Temis se centre en el documento o los documentos seleccionados, resultando en una búsqueda más enfocada y meticulosa en el tema o temas de interés. Al activar la función de filtrado, se desplegarán los documentos disponibles para que seleccione aquellos que sean más pertinentes para su consulta.
                    </p>

                    <div className={`info-box ${themeClass}`}>
                        <div className="info-icon">ℹ️</div>
                        <div className="info-content">
                        Actualmente, la base de datos de Temis incluye únicamente los documentos disponibles en el filtro de documentos. Al seleccionar uno o varios, la búsqueda se realizará solo dentro de esos textos, y aun sin usar el filtro, Temis solo puede consultar la información existente en su base de datos. Aunque estamos trabajando continuamente para ampliar y actualizar los documentos disponibles, agradecemos su comprensión mientras avanzamos en este proceso.                        </div>
                    </div>
                </div>

                {/* Best Practices Section */}
                <div className={`manual-section ${themeClass}`} id="Recomendaciones">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>03</span>
                        <h2 className="section-titleM">Recomendaciones de Búsqueda</h2>
                    </div>

                    <div className="practices-grid">
                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className="practice-icon">❌</span>
                                <h3>Evite preguntar directamente por el número de artículo</h3>
                            </div>
                            <p className="practice-description">
                                Temis funciona como un buscador temático; interpreta su consulta, identifica el tema central y luego compara este tema con el contenido de todo el marco legal para encontrar los artículos relacionados. Por lo tanto, preguntar directamente por el contenido de un número de artículo específico probablemente no le proporcionará una respuesta útil.
                            </p>
                            <div className={`practice-example wrong ${themeClass}`}>
                                <div className={`example-label ${themeClass}`}>❌ No recomendado</div>
                                <img src={manuel4} alt="Ejemplo incorrecto" />
                            </div>
                            <p className="practice-description">
                                Por el contrario, una consulta efectiva se centrará en el tema legal en cuestión, en lugar de referirse a números de artículos específicos.
                            </p>
                            <div className={`practice-example correct ${themeClass}`}>
                                <div className={`example-label ${themeClass}`}>✅ Recomendado</div>
                                 <img 
                                    src={isDarkMode ? manual3D : manual3} 
                                    alt="EjemploCorrecto"                            
                                />
                            </div>
                        </div>

                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className={`section-number ${themeClass}`}>🇬🇹</span>
                                <h3>Evite usar la palabra "Guatemala"</h3>
                            </div>
                            <p className="practice-description">
                                Dado que Temis está diseñado específicamente para el contexto legal guatemalteco, la inclusión de la palabra "Guatemala" en su consulta podría resultar redundante y podría llevar a Temis a generar respuestas demasiado generalizadas.
                            </p>
                        </div>

                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className="practice-icon">🔄</span>
                                <h3>Genere múltiples respuestas</h3>
                            </div>
                            <p className="practice-description">
                                Como Temis es una Inteligencia Artificial, puede proporcionar diferentes respuestas a una misma consulta. Por lo tanto, si no está satisfecho con la respuesta inicial de Temis, le recomendamos que genere varias respuestas hasta encontrar la que le resulte más útil.
                            </p>
                            <p className="practice-description">
                                Además, le instamos a leer detenidamente nuestra política de uso para obtener una orientación más detallada sobre las respuestas proporcionadas por Temis. Nuestro objetivo es ayudarle a hacer un uso efectivo y responsable de nuestra herramienta, al tiempo que aseguramos su comprensión completa de sus funciones y limitaciones.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Closing Section */}
                <div className={`manual-closing ${themeClass}`}>
                    <div className="closing-content">
                        <h2>Gracias por confiar en Temis</h2>
                        <p>
                            En nombre del equipo de Temis, le agradecemos su interés y confianza en nuestra herramienta. Como startup, trabajamos constantemente para mejorar y ampliar nuestras capacidades, con el objetivo de facilitar el acceso y la comprensión del marco legal guatemalteco. Valoramos profundamente sus comentarios y sugerencias, ya que nos permiten crecer junto a nuestros usuarios y hacer de Temis una herramienta cada vez más útil y accesible para todos.
                        </p>
                        <div className="closing-signature">
                            De todo corazón, gracias.
                            <br />
                            <strong>— El equipo de Temis</strong>
                        </div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className={`manual-cta ${themeClass}`}>
                    <h1 className="manual-hero-title">¿Listo para comenzar?</h1>
                    <p className="manual-hero-description">Temis, Inteligencia Artificial aplicada a la Ley</p>
                    <div className="cta-buttons">
                        <button onClick={login} className={`color-button ${themeClass}`}>
                            Comenzar
                        </button>
                        <button onClick={politica} className={`politicas color-button red ${themeClass}`}>
                            Leer Política de Uso
                        </button>
                    </div>
                    
                    <div className='mediaIcons'>
                        <img 
                            src={isDarkMode ? xDark  : xLight} 
                            alt="twitter" 
                            className="social"
                            onClick={() => window.open("https://twitter.com/temisgpt", "_blank")}
                        />
                        <img 
                            src={isDarkMode ? igDark : igLight} 
                            alt="instagram" 
                            className="social"
                            onClick={() => window.open("https://www.instagram.com/temis.ia/", "_blank")}
                            
                        />
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Manuel;